module.exports = __webpack_public_path__ + "fonts/text-security-disc.b197495.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/text-security/dist/text-security-disc.eot
// module id = 566
// module chunks = 0 4 5